export enum StagedInput {
  Low = 'LOW',
  Normal = 'NORMAL',
  High = 'HIGH',
}
